import React, { useState, useEffect } from "react";
import "./paymentPendingSection.css";
import {
  ClockIcon,
  CheckCircleIcon,
  XCircleIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";
import confetti from "canvas-confetti";

function PaymentPendingSection({
  paymentData,
  paymentMethod,
  setPage,
  selectedPlan,
}) {
  const [lastUpdate, setLastUpdate] = useState(new Date());
  const [currentPlan, setCurrentPlan] = useState(selectedPlan || {});
  const [isRedirectingAfterResult, setIsRedirectingAfterResult] =
    useState(false);

  useEffect(() => {
    if (selectedPlan && selectedPlan.currency) {
      setCurrentPlan(selectedPlan);
    } else if (paymentData && paymentData.plan) {
      setCurrentPlan(paymentData.plan);
    } else {
      setCurrentPlan({});
    }
  }, [selectedPlan, paymentData]);

  useEffect(() => {
    if (paymentData?.payment?.status === "pending") {
      setLastUpdate(new Date());
    }
  }, [paymentData]);

  useEffect(() => {
    if (["completed", "failed"].includes(paymentData?.payment?.status)) {
      setIsRedirectingAfterResult(true);

      if (paymentData?.payment?.status === "completed") {
        confetti({
          particleCount: 150,
          spread: 70,
          origin: { y: 0.6 },
          colors: ["#FFD700", "#FFA500", "#FF8C00", "#DAA520", "#B8860B"],
        });
      }

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  }, [paymentData?.payment?.status, setPage]);

  const getStatusIcon = () => {
    switch (paymentData?.payment?.status) {
      case "pending":
        return (
          <ClockIcon className="orion__status-icon orion__status-pending" />
        );
      case "completed":
        return (
          <CheckCircleIcon
            className={`orion__status-icon orion__status-success ${isRedirectingAfterResult ? "orion__status-icon--processing" : ""}`}
          />
        );
      case "failed":
        return (
          <XCircleIcon
            className={`orion__status-icon orion__status-error ${isRedirectingAfterResult ? "orion__status-icon--processing" : ""}`}
          />
        );
      default:
        return (
          <ClockIcon className="orion__status-icon orion__status-pending" />
        );
    }
  };

  const getStatusMessage = () => {
    if (isRedirectingAfterResult) {
      if (paymentData?.payment?.status === "completed") {
        return "Pagamento confirmado! Redirecionando em alguns segundos...";
      } else if (paymentData?.payment?.status === "failed") {
        return "Pagamento falhou. Redirecionando em alguns segundos...";
      }
    }

    switch (paymentData?.payment?.status) {
      case "pending":
        return "Aguardando confirmação do pagamento...";
      case "completed":
        return "Pagamento confirmado! Redirecionando...";
      case "failed":
        return "Pagamento falhou. Redirecionando...";
      default:
        return "Verificando status do pagamento...";
    }
  };

  const getPaymentMethodText = () => {
    return paymentMethod === "pix" ? "PIX" : "Criptomoeda";
  };

  return (
    <div className="orion__payment-pending">
      <div className="orion__plan-summary-detailed">
        <div className="orion__plan-info">
          <h4>Preço selecionado</h4>
          <div className="orion__plan-details">
            <div className="orion__plan-price">
              <span className="orion__amount">{currentPlan.price}</span>
              <span className="orion__currency">{currentPlan.currency}</span>
            </div>
            <div className="orion__plan-duration">
              <strong>{currentPlan.duration_in_days} dias</strong> de acesso
              completo
            </div>
            <div className="orion__payment-method">
              Pagamento via {getPaymentMethodText()}
            </div>
          </div>
        </div>
      </div>

      <div className="orion__status-container">
        <div className="orion__status-visual">{getStatusIcon()}</div>

        <div className="orion__status-text">
          <h4>{getStatusMessage()}</h4>
          {paymentData?.payment?.status === "pending" && (
            <p>
              Verificamos automaticamente o status do seu pagamento. Por favor,
              aguarde a confirmação.
            </p>
          )}
          {paymentMethod === "crypto" && paymentData.payment.invoice_url && (
            <div className="orion__crypto-fallback-link">
              <small>
                <p>Não foi redirecionado? </p>
                <a
                  href={paymentData.payment.invoice_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="orion__support-link"
                >
                  Clique aqui para acessar o link de pagamento.
                </a>
              </small>
            </div>
          )}
        </div>
      </div>

      {paymentData?.payment?.status === "pending" && (
        <div className="orion__pending-info-block">
          <InformationCircleIcon className="orion__info-icon orion__info-icon--pending-block" />
          <div className="orion__info-text">
            <div className="orion__pending-info-header">
              <strong className="orion__info-title--pending-block">
                Pode fechar essa página!
              </strong>
              <small className="orion__pending-info-update">
                Última atualização: {lastUpdate.toLocaleTimeString()}
              </small>
            </div>
            <small className="orion__info-desc--pending-block">
              {paymentMethod === "crypto"
                ? "Pagamentos em criptomoeda podem levar alguns minutos. Você pode sair e voltar. Automaticamente mostraremos o status quando retornar."
                : "Você pode sair desta página e voltar mais tarde. Quando retornar, mostraremos automaticamente o status do seu pagamento."}
            </small>
          </div>
        </div>
      )}
    </div>
  );
}

export default PaymentPendingSection;
